import axiosInstance from "../../Config/axiosConfig";

export const getCoinStore = async () => {
  try {
    const response = await axiosInstance.get('/user/coin-packages');
    return response.data.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const createCoinPaymentIntent = async (amount) => {
  try {
    const response = await axiosInstance.post('/user/payment-intent', {
      amount: amount
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const purchaseCoins = async (packageId, paymentIntentId) => {
  try {
    const response = await axiosInstance.post('/user/coins/purchase', {
      coin_package_id: packageId,
      payment_intent_id: paymentIntentId
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};